import { Apple, Chest, Star, Tree, Wall, Water } from './Default';
import { TokenIcons } from './types';

export const DefaultTokens: TokenIcons = {
  star: Star,
  apple: Apple,
  chest: Chest,
  wall: Wall,
  tree: Tree,
  water: Water,
};
